import { BaseLineMinus } from '@/app/components/icons/BaseLineMinus';
import { cn } from '@/app/utils';

export const DeleteBtn = ({ onClick, className }: { onClick: () => void; className?: string }) => {
  return (
    <div
      className={cn(
        '-top-1 -right-1 absolute flex size-4 cursor-pointer items-center justify-center rounded-full bg-system-white24 text-system-white backdrop-blur-[2px]',
        className,
      )}
      onClick={onClick}
    >
      <BaseLineMinus className="size-4" />
    </div>
  );
};
